import { checkForDuplicateGroups } from '@/redux/util';

export const removeGroups = (groupIDs, material) => {
	const groupsToRemove = groupIDs.map(group => group.id);
	material.groups = material.groups.filter(group => !groupsToRemove.includes(group.id));
};

export const addGroups = (groupIDs, material) => {
	const newGroups = checkForDuplicateGroups(material.groups, groupIDs);
	material.groups = [...material.groups, ...newGroups];
};
